import React, { SVGProps } from 'react';
import {
  AmexPaymentMethodIcon,
  ArgencardPaymentMethodIcon,
  CabalPaymentMethodIcon,
  CmrFalabellaPaymentMethodIcon,
  DinersPaymentMethodIcon,
  DiscoverPaymentMethodIcon,
  MaestroPaymentMethodIcon,
  MastercardPaymentMethodIcon,
  MercadoPagoPaymentMethodIcon,
  NaranjaPaymentMethodIcon,
  NativaPaymentMethodIcon,
  TarjetaShoppingPaymentMethodIcon,
  VisaDebitoPaymentMethodIcon,
  VisaPaymentMethodIcon
} from '@increasecard/icons';
import { useTranslation } from 'react-i18next';

type cardBrandOptions = {
  [key: string]: (props: SVGProps<SVGSVGElement>) => JSX.Element;
};

const cardBrandsIcons: cardBrandOptions = {
  amex: AmexPaymentMethodIcon,
  argencard: ArgencardPaymentMethodIcon,
  cabal: CabalPaymentMethodIcon,
  cmr: CmrFalabellaPaymentMethodIcon,
  diners: DinersPaymentMethodIcon,
  discover: DiscoverPaymentMethodIcon,
  maestro: MaestroPaymentMethodIcon,
  // eslint-disable-next-line @typescript-eslint/camelcase
  mastercard_debit: MastercardPaymentMethodIcon,
  mastercard: MastercardPaymentMethodIcon,
  mercadopago: MercadoPagoPaymentMethodIcon,
  naranja: NaranjaPaymentMethodIcon,
  nativa: NativaPaymentMethodIcon,
  tarjetashopping: TarjetaShoppingPaymentMethodIcon,
  // eslint-disable-next-line @typescript-eslint/camelcase
  visa_debit: VisaDebitoPaymentMethodIcon,
  visa: VisaPaymentMethodIcon
};

const CardBrandIcon = ({ cardBrand }: { cardBrand: string }) => {
  const { t } = useTranslation('common');
  const displayName = t(`cardBrands.${cardBrand}`);
  const Component = cardBrandsIcons[cardBrand];

  if (Component === undefined) return null;

  return (
    <span aria-label={displayName} title={displayName}>
      <Component />
    </span>
  );
};

export default CardBrandIcon;
